import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "14",
  fill: "none",
  viewBox: "0 0 40 14"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#3362AB",
  d: "M37.31 1.035h-2.515c-.76 0-1.345.234-1.696.994l-4.795 10.936h3.392s.585-1.462.702-1.813h4.152c.117.41.409 1.754.409 1.754H40L37.31 1.035Zm-3.977 7.66c.293-.701 1.287-3.333 1.287-3.333 0 .059.292-.701.41-1.11l.233 1.052s.643 2.865.76 3.45h-2.69v-.058Zm-4.795.352c0 2.456-2.222 4.093-5.672 4.093-1.462 0-2.866-.292-3.626-.643l.468-2.69.409.175c1.053.468 1.754.644 3.04.644.936 0 1.93-.351 1.93-1.17 0-.526-.409-.877-1.695-1.462-1.228-.585-2.866-1.52-2.866-3.216 0-2.34 2.281-3.918 5.497-3.918 1.228 0 2.281.234 2.924.526l-.467 2.573-.234-.234a6.284 6.284 0 0 0-2.456-.468c-1.229.059-1.813.585-1.813 1.053 0 .526.701.936 1.813 1.462 1.87.877 2.748 1.871 2.748 3.275Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F9B50B",
  d: "M0 1.152.058.918h5.03c.701 0 1.228.234 1.403.994l1.111 5.264C6.492 4.368 3.918 2.088 0 1.152Z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#3362AB",
  d: "M14.678 1.035 9.591 12.906H6.14L3.215 2.965c2.106 1.345 3.86 3.45 4.503 4.912l.351 1.228L11.228.977h3.45v.058Zm1.345-.058h3.217l-2.047 11.93h-3.216L16.023.976Z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }